import React, { useEffect } from 'react';
import { random, get } from 'lodash-es';
import PartialsHeader from '../Partials/PartialsHeader';
import PartialsQuestion from '../Partials/PartialsQuestion';
import BlogRoll from './BlogRoll';
import BlogCategories from './BlogCategoriesRouted';
import { capitalize } from '../../helpers/util';
import meta from './metaForTopics.json';
import SEO from '../SEO';

export default ({ location, posts }) => {
  const urlParts = location.pathname.split('/');
  const activeCategory = urlParts.pop() || urlParts.pop(); // handle trailing slash if any

  const ctaPosition = random(1, posts.length - 1, false) || 1;
  posts.splice(ctaPosition, 0, { id: 'cta' });

  useEffect(() => {
    // return to previous scroll position. Note that for this to work, blog related pages are
    // whitelisted from shouldUpdateScroll in gatsby-browser.js
    const scrollY = get(location, 'state.scrollY');
    if (scrollY) {
      window.scrollTo(0, scrollY);
    }
  }, []);

  const isAll = activeCategory === 'blog';

  let displayName = 'All posts';
  let metatags = {
    title: 'Blog on software development best practices | Ulam Labs',
    description: `Learn more about Python and blockchain development solutions. Get relevant information about platforms, programming, business and how we deliver software.`
  };

  if (!isAll) {
    displayName = activeCategory;
    const capitalized = capitalize(displayName);
    const defaultTags = {
      title: `${capitalized} - use cases across industries, news, tips & tricks | Ulam Labs`,
      description: `What is ${capitalized} and how to use it for your business? Read blogposts related to ${activeCategory.toLowerCase()}.`
    };
    metatags = get(meta, activeCategory, defaultTags);
  }

  return (
    <>
      <SEO
        url={location.href}
        title={metatags.title}
        description={metatags.description}
      />
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">Blog</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <BlogCategories activeCategory={activeCategory} />
      <div className="knowledge text-format">
        <div className="container">
          <div className="content">
            <BlogRoll location={location.href} posts={posts} />
          </div>
        </div>
      </div>
      <PartialsQuestion />
    </>
  );
};
